import React from "react";
import { unstable_HistoryRouter as HistoryRouter, Routes as RouterRoutes, Route } from "react-router-dom";

import { history, withRouterProps } from "../router.jsx";

import App from "./App.jsx";
import Login from "./Login.jsx";

import AuditStoreDetails from "./AuditStoreDetails.jsx";
import AuditStoreDashboard from "./AuditStoreDashboard.jsx";

import AuditStoreQARatingForm from "./AuditStoreQARatingForm.jsx";
import AuditStoreAuditorRating from "./AuditStoreAuditorRatingForm.jsx";
import AuditStoreEarningsPerAuditForm from "./AuditStoreEarningsPerAuditForm.jsx";
import AuditStoreReimbursementForm from "./AuditStoreReimbursementForm.jsx";
import AuditStoreChange from "./AuditStoreChange.jsx";
import ReportFail from "./ReportFail.jsx";

// Layout/page components still expect v3-shaped `params`/`location`/`router`/
// `children` props (see ../router.jsx for why), so every routed component is
// wrapped with the shim here rather than being changed internally.
const LoginRoute = withRouterProps(Login);
const AppRoute = withRouterProps(App);
const AuditStoreDashboardRoute = withRouterProps(AuditStoreDashboard);
const AuditStoreDetailsRoute = withRouterProps(AuditStoreDetails);
const AuditStoreQARatingFormRoute = withRouterProps(AuditStoreQARatingForm);
const AuditStoreAuditorRatingRoute = withRouterProps(AuditStoreAuditorRating);
const AuditStoreEarningsPerAuditFormRoute = withRouterProps(AuditStoreEarningsPerAuditForm);
const AuditStoreReimbursementFormRoute = withRouterProps(AuditStoreReimbursementForm);
const AuditStoreChangeRoute = withRouterProps(AuditStoreChange);
const ReportFailRoute = withRouterProps(ReportFail);

const Routes = () => (
	<HistoryRouter history={history}>
		<RouterRoutes>
			<Route path="/login" element={<LoginRoute/>}/>
			<Route path="/" element={<AppRoute/>}>
				<Route index element={<AuditStoreDashboardRoute/>} />
				{/*
			<Route path="audit_cycle/:auditCycleId" element={<AuditCycleDetailsRoute/>}>
				<Route path="audit_store" element={<AuditStoreListRoute/>}/>
			</Route>
			*/}
				<Route path="audit_store/:auditStoreId/report" element={<AuditStoreDetailsRoute/>}>
					<Route path="rate" element={<AuditStoreQARatingFormRoute/>}/>
					<Route path="earnings_per_audit" element={<AuditStoreEarningsPerAuditFormRoute/>}/>
					<Route path="reimbursement" element={<AuditStoreReimbursementFormRoute/>}/>
					<Route path="store_change" element={<AuditStoreChangeRoute/>}/>
					<Route path="auditor_rate" element={<AuditStoreAuditorRatingRoute/>}/>
					<Route path="fail" element={<ReportFailRoute/>}/>
				</Route>
			</Route>
		</RouterRoutes>
	</HistoryRouter>
);

export default Routes;
